import React, { lazy, Suspense } from "react";

import useIsClient from "../../lib/useIsClient";
import { useLocalStorage } from "../../lib/useLocalStorage";
import { guidedTourSteps } from "./guidedTourSteps";

const ShepherdTour = lazy(() => import("../shepherdTour/ShepherdTour"));

export const GuidedTour = () => {
  const [guidedTourVisited, setGuidedTourVisited] = useLocalStorage("GuidedTourVisited", false);
  const { isClient } = useIsClient();

  const onTourStart = () => {
    setGuidedTourVisited(true);
  };

  if (!isClient || guidedTourVisited) {
    return null;
  }

  return (
    <Suspense fallback={<div />}>
      <ShepherdTour onTourStart={onTourStart} steps={guidedTourSteps} />
    </Suspense>
  );
};
